// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import { FaFacebookF, FaInstagram, FaLinkedin, FaPinterest, FaTwitter, FaYoutube } from 'react-icons/fa'
import { SiTiktok } from 'react-icons/si'
import styled from 'styled-components'

// Style Imports
import { above, colors } from '../../style/design-system'

const SocialLinks = ({ className, fontSizeOverrides, horizontalMarginOverride, showHoverColor }) => (
  <div className={`${className} social-icons`}>
    <a
      href="https://www.facebook.com/umaonline/"
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Ultimate Medical Academy on Facebook">
      <FaFacebookF className="facebook" />
    </a>
    <a
      href="https://www.instagram.com/ultimatemedicalacademy/"
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Ultimate Medical Academy on Instagram">
      <FaInstagram className="instagram" />
    </a>
    {/* <a href="https://www.tiktok.com/@ultimatemedicalacademy" rel="noopener noreferrer" target="_blank" aria-label="Ultimate Medical Academy on Instagram" className="tiktok-wrapper position-relative">
      <SiTiktok className="tiktok-a position-absolute" />
      <SiTiktok className="tiktok-b position-absolute" />
      <SiTiktok className="tiktok-c position-absolute" />
    </a> */}
    <a
      href="https://www.linkedin.com/school/ultimate-medical-academy/"
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Ultimate Medical Academy on LinkedIn">
      <FaLinkedin className="linkedin" />
    </a>
    <a
      href="https://twitter.com/UltimateMedical"
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Ultimate Medical Academy on Twitter">
      <FaTwitter className="twitter" />
    </a>
    <a
      href="https://www.pinterest.com/ultimatemedical/"
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Ultimate Medical Academy on Pinterest">
      <FaPinterest className="pinterest" />
    </a>
    <a
      href="https://www.youtube.com/channel/UCZKEpFCt6DQKM_eyZ3jJhGw"
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Ultimate Medical Academy on YouTube">
      <FaYoutube className="youtube" />
    </a>
  </div>
)

export default styled(SocialLinks)`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  ${above.sm`
    justify-content: flex-start;
  `}
  a {
    margin: ${(props) => (props.horizontalMarginOverride ? `0 ${props.horizontalMarginOverride}` : '0 .625rem')};
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    svg {
      font-size: 1rem;
      color: ${(props) => (props.colorOverride ? `${props.colorOverride}` : `${colors.umaDarkGray}`)};
      transition: all 0.3s ease-in-out;
      ${above.tiny`
        font-size: 1.75rem;
      `}
      ${above.sm`
        font-size: 2.5rem;
      `}
      ${above.md`
        font-size: 2.1rem;
      `}
      ${above.lg`
        font-size: 3rem;
      `}
      ${above.xl`
        font-size: 4rem;
      `}
      &:hover {
        transform: scale(1.1);
      }
      &.facebook:hover,
      &.facebook:active {
        color: ${(props) => (props.showHoverColor ? `${colors.social.facebook}` : '#fff')};
      }
      &.instagram:hover,
      &.instagram:active {
        color: ${(props) => (props.showHoverColor ? `${colors.social.instagram}` : '#fff')};
      }
      &.linkedin:hover,
      &.linkedin:active {
        color: ${(props) => (props.showHoverColor ? `${colors.social.linkedIn}` : '#fff')};
      }
      &.pinterest:hover,
      &.pinterest:active {
        color: ${(props) => (props.showHoverColor ? `${colors.social.pinterest}` : '#fff')};
      }
      &.twitter:hover,
      &.twitter:active {
        color: ${(props) => (props.showHoverColor ? `${colors.social.twitter}` : '#fff')};
      }
      &.youtube:hover,
      &.youtube:active {
        color: ${(props) => (props.showHoverColor ? `${colors.social.youTube}` : '#fff')};
      }
    }
    &.tiktok-wrapper {
      width: 1rem;
      height: 1rem;
      align-self: center;
      ${above.tiny`
        width: 1.75rem;
        height: 1.75rem;
      `}
      ${above.sm`
        width: 2.5rem;
        height: 2.5rem;
      `}
      ${above.md`
        width: 2.1rem;
        height: 2.1rem;
      `}
      ${above.lg`
        width: 3rem;
        height: 3rem;
      `}
      ${above.xl`
        width: 4rem;
        height: 4rem;
      `}
      &:hover {
        .tiktok-a {
          color: ${colors.social.tiktokTeal};
          transform: translate(-2px, -2px) scale(1.1);
        }
        .tiktok-b {
          color: ${colors.social.tiktokRed};
          transform: translate(2px, 2px) scale(1.1);
        }
        .tiktok-c {
          color: #000;
          transform: scale(1.1);
        }
      }
    }
  }
`

SocialLinks.propTypes = {
  colorOverride: PropTypes.string,
  fontSizeOverrides: PropTypes.object,
  horizontalMarginOverride: PropTypes.string,
  showHoverColor: PropTypes.bool,
}

SocialLinks.defaultProps = {
  fontSizeOverrides: {},
  showHoverColor: false,
}
